import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { TransactionFile } from "../_types/transaction-file";

@Injectable({
    providedIn: 'root',
})
export class TransactionsFilesService extends Service<TransactionFile> {
    public override type = 'transactionFiles';
    public override url = 'invoicing/transactionFiles';
}
